export default __webpack_public_path__ + "static/media/5-kayaking_in_the_fjords.8886b0d7.jpg";